<main class="dialog-create-user">

    <div>
        <h1
            mat-dialog-title class="dialog-create-user_title">
            <strong>
            {{"AddUser" | translate}}
            </strong>
        </h1>

        <ng-template #loading>
          <div class="loading-container">
            <div  class="pulsing">
              <mat-spinner [diameter]="50" ></mat-spinner>
            </div>
            <p class="pulsing">{{"Loading" | translate}}</p>
          </div>
        </ng-template>

        <div mat-dialog-content class="dialog-create-user_content" *ngIf="graphDropdowns$| async as graphDropdowns; else loading">
          <form [formGroup]="createUserForm" >
            <div
              class="dialog-create-user_country"
              *ngIf="ownerRoleId === 4"
            >
              <h3
                mat-dialog-subtitle
                class="dialog-create-user_subtitle"
              >
                {{"Country" | translate}}:
              </h3>
              <h3 class="dialog-create-user_country_name">
                {{graphDropdowns[1].countryName}}
              </h3>

            </div>

            <div class="dialog-create-user__incadea" *ngIf="helperService.user.role.roleId === 7">
              <p [ngClass]="{ 'disabled': createUserForm.value.userMix === true }">{{"UserIncadea" | translate}}</p>
              <div>
                <mat-radio-group
                  aria-label="Select an option"
                  formControlName ="userIncadea"
                  (change)="onRadioChange($event)"
                  >
                  <mat-radio-button  [value]="true" labelPosition="before" [disabled]="createUserForm.value.userMix === true"
                    >{{"Yes" | translate}}</mat-radio-button
                  >
                  <mat-radio-button  [value]="false" labelPosition="before" [disabled]="createUserForm.value.userMix === true"
                    >{{"No" | translate}}</mat-radio-button
                  >
                </mat-radio-group>
              </div>
            </div>

            <div class="dialog-create-user__wrapper">
                <div>
                  <mat-form-field>
                    <mat-label class="dialog-create-user__label"
                      >{{"FirstName"| translate}}</mat-label
                    >
                    <input
                    oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                      matInput
                      type="text"
                      formControlName="name"
                      maxlength="20"
                    />
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field>
                    <mat-label class="dialog-create-user__label"
                      >{{"LastName" | translate}}</mat-label
                    >
                    <input
                    oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                      matInput
                      type="text"
                      formControlName="lastName"
                      maxlength="20"
                    />
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field>
                    <mat-label
                      class="dialog-create-user__label"
                    >
                    {{"InstitutionalEmail" | translate}}
                    </mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="email"
                      maxlength="40"
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      emailControl?.invalid &&
                      (emailControl?.touched || emailControl?.dirty)
                    "
                  >
                    <p
                      class="error-ms"
                      *ngIf="emailControl.errors?.['required']"
                    >
                      {{"ObligatoryField" |translate}}
                    </p>
                    <p
                      class="error-ms"
                      *ngIf="emailControl.errors?.['invalidEmail']"
                    >
                    {{"Invalidemail" |translate}}
                    </p>
                    <p
                    class="error-ms"
                    *ngIf="emailControl.errors?.['noSpecialChars']"
                  >
                  {{"noSpecialChars" |translate}}
                  </p>
                  </div>
                </div>

                <div *ngIf="ownerRoleId === 7">
                  <mat-form-field>
                    <mat-label
                      class="dialog-create-user__label"
                    >
                      {{"Country" | translate}}
                    </mat-label>
                    <mat-select
                      formControlName="countryName"
                    >
                      <mat-option
                        *ngFor="let country of graphDropdowns[0][0]"
                        [value]="country.CountryId"
                        (click)="selectCountry(country.CountryId)"
                      >
                        {{country.CountryName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div >
                  <mat-form-field>
                    <mat-label
                      class="dialog-create-user__label"
                    >
                      {{"Language" | translate}}
                    </mat-label>
                    <mat-select

                      formControlName="language"
                    >
                      <mat-option
                      *ngFor="let language of languages"
                      [value]="language.codeLanguage"
                      >
                        {{language.nameLanguage | translate}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div *ngIf="ownerRoleId === 7">
                    <mat-form-field>
                      <mat-label
                        class="dialog-create-user__label"
                      >
                        {{"Role" | translate}}
                      </mat-label>
                      <mat-select
                        formControlName="rol"
                      >
                        <mat-option
                          *ngFor="let role of graphDropdowns[0][1]"
                          [value]="role.RoleId"
                          (click)="selectRetailId()"
                        >
                          {{role.RoleName  | translate }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>
                
                <div *ngIf="ownerRoleId === 4">
                  <mat-form-field>
                    <mat-label
                      class="dialog-create-user__label"
                    >
                      {{"Role" | translate}}
                  </mat-label>
                    <mat-select
                      formControlName="rol"

                    >
                      <mat-option
                        *ngFor="let role of graphDropdowns[0][0]"
                        [value]="role.RoleId"
                        (click)="selectworkshop()"
                      >
                        {{role.RoleName | translate}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="createUserForm.value.userIncadea === false && ownerRoleId === 7 && (createUserForm.value.rol === 1 || createUserForm.value.rol === 2 || createUserForm.value.rol === 6 ||createUserForm.value.rol === 4 )">
                  <mat-form-field>
                    <mat-label  class="dialog-create-user__label">
                      {{"RetailName" | translate}}
                    </mat-label>

                    <mat-select
                      formControlName="retailName"
                    >
                      <mat-option
                        *ngFor="let retail of retailList"
                        [value]="retail.RetailId"
                        (click)="selectworkshop()"
                      >
                        {{retail.RetailGroupName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div  *ngIf="createUserForm.value.rol === 1 || createUserForm.value.rol === 2 || createUserForm.value.rol === 6">
                  <mat-form-field>
                    <mat-label  class="dialog-create-user__label">
                      {{"Workshop" | translate}}
                    </mat-label>

                    <mat-select
                      formControlName="workshopName"
                    >
                      <mat-option
                      *ngFor="let role of workshopList"
                      [value]="role.WorkshopId"
                      (click)="selectAdvisor()"
                      >
                      {{role.WorkshopName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div *ngIf="createUserForm.value.rol === 1">
                  <div>
                    <mat-form-field>
                      <mat-label  class="dialog-create-user__label">
                        {{"Advisor" | translate}}
                      </mat-label>

                      <mat-select
                        formControlName="advisorName"

                      >
                        <mat-option
                        *ngFor="let advisor of AdvisorList"
                        [value]="advisor.AdvisorId"
                        >
                        {{advisor.AdvisorFullName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <!-- *review -->
                <div *ngIf ="createUserForm.value.userIncadea === true && createUserForm.value.rol === 4">
                  <mat-form-field>
                    <mat-label class="dialog-create-user__label"
                      >Company ID</mat-label
                    >
                    <input
                      matInput
                      type="text"
                      formControlName="companyID"
                      maxlength="40"
                      oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                    />
                  </mat-form-field>
                </div>



            </div>
            <div class="dialog-create-user__incadea" *ngIf="createUserForm.value.rol === 3">
              <p>{{"UserMix" | translate}}</p>
              <div>
                <mat-radio-group
                  aria-label="Select an option"
                  formControlName ="userMix"
                  (change)="onRadioChangeUserMix($event)"
                  >
                  <mat-radio-button  [value]="true" labelPosition="before"
                    >{{"Yes" | translate}}</mat-radio-button
                  >
                  <mat-radio-button  [value]="false" labelPosition="before"
                    >{{"No" | translate}}</mat-radio-button
                  >
                </mat-radio-group>
              </div>
            </div>

            <h2 class="dialog-create-user_subtitle">
              {{"SelectStatusUser" | translate}}
            </h2>

            <td style="width: 15%; font-size: 16px; text-align: center">


                <mat-label
                  class="switch-right-label"
                > {{isActive
                    ? ('Active' | translate | capitalize)
                    : ('Inactive' | translate | capitalize)}}
                <mat-slide-toggle
                  size="small"
                  class="custom-switch"
                  formControlName="isActive"
                  [(ngModel)]="isActive"
                ></mat-slide-toggle>
              </mat-label>
              </td>
          </form>
        </div>
        <div *ngIf="!isLoadingSave">
          <section class="dialog-loading-container">
            <div  class="pulsing">
              <mat-spinner [diameter]="50" ></mat-spinner>
            </div>
            <p class="pulsing">{{"Loading" | translate}}</p>
          </section>
        </div>
        <mat-dialog-actions
          align="center"
          [ngClass]="{'contenido-deshabilitado': !isLoadingSave}"
        >
            <button class="dialog__button" [mat-dialog-close]>
              {{"Cancel" | translate}}
            </button>
            <button
              class="dialog__button dialog__acept"
              [ngClass]="createUserForm.invalid ? 'dialog__button--disabled' : 'dialog__button--fill'"
              (click)="onSaveCreateUser()"
              [disabled]= "formsValidations() "
            >
              {{"Accept" | translate}}
            </button>
        </mat-dialog-actions>
    </div>

</main>
